import aqilaApi from './aqila-api';
import { GrupoInsumo } from '../@types';

class GruposInsumo {
  private readonly endpoint = 'v1/grupos';

  async list() {
    const { data } = await aqilaApi.get<GrupoInsumo[]>(this.endpoint);
    return data;
  }
}

export default new GruposInsumo();
